import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const MaestroCard = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={32}
        height={20}
        viewBox='0 0 32 20'
        fill='none'
    >
        <path
            d='M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V18C32 19.1046 31.1046 20 30 20H2C0.895431 20 0 19.1046 0 18V2Z'
            fill='white'
        />
        <path
            d='M2 0.5H30C30.8284 0.5 31.5 1.17157 31.5 2V18C31.5 18.8284 30.8284 19.5 30 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2C0.5 1.17157 1.17157 0.5 2 0.5Z'
            stroke='#101D3A'
            strokeOpacity='0.1'
        />
        <path
            d='M18.1634 6.11234H13.8369V13.8871H18.1634V6.11234Z'
            fill='#FF5F00'
        />
        <path
            d='M14.1116 10C14.1109 9.25124 14.2806 8.51213 14.6078 7.83864C14.935 7.16514 15.4111 6.57491 16.0001 6.11262C15.2707 5.53928 14.3947 5.18273 13.4722 5.08372C12.5497 4.98471 11.618 5.14724 10.7835 5.55272C9.94904 5.95821 9.24548 6.59029 8.75325 7.37673C8.26103 8.16317 8 9.07223 8 10C8 10.9278 8.26103 11.8368 8.75325 12.6233C9.24548 13.4097 9.94904 14.0418 10.7835 14.4473C11.618 14.8528 12.5497 15.0153 13.4722 14.9163C14.3947 14.8173 15.2707 14.4607 16.0001 13.8874C15.4111 13.4251 14.935 12.8349 14.6078 12.1614C14.2806 11.4879 14.1109 10.7488 14.1116 10Z'
            fill='#EB001B'
        />
        <path
            d='M23.9998 10C23.9999 10.9278 23.7389 11.8368 23.2467 12.6233C22.7545 13.4097 22.051 14.0418 21.2165 14.4473C20.382 14.8528 19.4503 15.0153 18.5279 14.9163C17.6054 14.8173 16.7294 14.4607 16 13.8874C16.5885 13.4246 17.0643 12.8343 17.3914 12.1609C17.7185 11.4875 17.8885 10.7487 17.8885 10C17.8885 9.25136 17.7185 8.51248 17.3914 7.83909C17.0643 7.1657 16.5885 6.57537 16 6.11262C16.7294 5.53928 17.6054 5.18273 18.5279 5.08372C19.4503 4.98471 20.382 5.14724 21.2165 5.55273C22.051 5.95822 22.7545 6.59031 23.2467 7.37675C23.7389 8.16319 23.9999 9.07224 23.9998 10Z'
            fill='#F79E1B'
        />
        <path
            d='M23.5285 13.0637V12.9046H23.5927V12.8721H23.4292V12.9046H23.4934V13.0637H23.5285ZM23.8458 13.0637V12.8718H23.7957L23.7381 13.0038L23.6804 12.8718H23.6303V13.0637H23.6657V12.919L23.7197 13.0438H23.7564L23.8105 12.9187V13.0637H23.8458Z'
            fill='#F79E1B'
        />
    </SvgElement>
);
